import theme from "./index";

const contentCardStyles = {
  backgroundColor: "white",
  border: `1px solid ${theme.palette.grey[300]}`,
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  height: "100%",
  overflow: "hidden",
};

export default contentCardStyles;
